import { getGuestTokenConfig } from "../constants";

// Team-format (grade 3) matches/group slots only carry team_id/team_name -
// the full player roster lives on the team record itself, not embedded in
// every match/group row - fetched on demand (the same endpoint
// MatchDetailsModal already uses for its own roster lookup, which feeds it
// down into SubMatchesPanel) only when someone actually opens the "who's on
// this team" menu.
export async function fetchTeamRoster(api, tournamentId, teamId) {
    if (!teamId) return [];
    try {
        const res = await api.get(`/api/v1.0/tournaments/teams/${teamId}/`, getGuestTokenConfig(tournamentId));
        return res.data?.players || [];
    } catch (e) {
        console.error("Failed to fetch team roster:", e);
        return [];
    }
}
